import Script from 'next/script';

import { adjustPathname, getUrlOrigin } from '@monoimin/utils/helpers';

export const OrganizationGVJsonLd = () => {
  const addresses = [
    {
      addressLocality: 'Los Angeles',
      postalCode: '90012',
      streetAddress: '301 N Main St',
      telephone: '+1 (424) 317-44-10',
      addressRegion: 'CA',
      addressCountry: 'US',
    },
  ];

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'Organization',
    name: 'My Golden Visa',
    description:
      'Everything you need to know about Golden Visa Programs around the world in one place. Detailed guides with information about obtainment process, requirements, eligibility, benefits and a lot more',
    foundingDate: '2023',
    slogan:
      'All information you need to know about Golden Visa Programs around the world in one place',
    url: adjustPathname(getUrlOrigin()),
    knowsAbout:
      'My Golden Visa helps people to know everything about residence by investment programs around the world with detailed guides.',

    logo: {
      '@type': 'ImageObject',
      url: '/images/logo.svg',
    },
    address: addresses,
  };

  return (
    <Script id='organization-jsonld' type='application/ld+json'>
      {JSON.stringify(schema)}
    </Script>
  );
};

export default OrganizationGVJsonLd;
